import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useProductSubmission = (onSubmit: (product: any) => void) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (
    name: string,
    quantity: string,
    unit: string,
    customUnit: string,
    price: string,
    minQuantity: string,
    isPoultry: boolean,
    poultryData?: {
      Age?: string;
      Santé?: string;
      Poids?: string;
      Régime?: string;
    }
  ) => {
    setIsLoading(true);
    console.log("Starting product submission with values:", {
      name,
      quantity,
      unit,
      price,
      minQuantity
    });

    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        console.error("No user found");
        toast.error("Vous devez être connecté pour ajouter un produit");
        return false;
      }

      const { data: businessStocks } = await supabase
        .from('business_stocks')
        .select('id')
        .eq('owner_id', user.id)
        .limit(1)
        .single();

      if (!businessStocks?.id) {
        console.error("No business stock found");
        toast.error("Erreur: Stock non trouvé");
        return false;
      }

      const finalUnit = unit === "custom" ? customUnit : unit;
      const productData = isPoultry ? {
        Race: name,
        unit: finalUnit,
        price: parseFloat(price),
        minQuantity: parseInt(minQuantity),
        status: parseInt(quantity) > 0 ? "En stock" : "Rupture",
        ...poultryData
      } : {
        name,
        unit: finalUnit,
        price: parseFloat(price),
        minQuantity: parseInt(minQuantity),
        status: parseInt(quantity) > 0 ? "En stock" : "Rupture"
      };

      const { data: newProduct, error: insertError } = await supabase
        .from('stock_items')
        .insert({
          stock_id: businessStocks.id,
          data: productData,
          quantity: parseInt(quantity)
        })
        .select()
        .single();

      if (insertError) {
        console.error("Erreur lors de l'ajout du produit:", insertError);
        toast.error("Erreur lors de l'ajout du produit");
        return false;
      }

      console.log("Product added successfully:", newProduct);
      toast.success("Produit ajouté avec succès");
      onSubmit(newProduct);
      return true;
    } catch (error) {
      console.error("Erreur inattendue:", error);
      toast.error("Une erreur inattendue s'est produite");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleSubmit
  };
};